import {
  FaHtml5,
  FaCss3,
  FaNodeJs,
  FaReact,
  FaSass,
  FaFigma,
  FaPhoneAlt,
  FaUser,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaDribbble,
  FaInstagram,
  FaLinkedin,
  FaGithub,
  FaLinux,
  FaStackOverflow,
  FaDigitalOcean,
} from "react-icons/fa";
import { DiJavascript } from "react-icons/di";
import { SiExpress, SiSequelize, SiTypescript } from "react-icons/si";
import { BsMedium } from "react-icons/bs";
import portfolio from "./assets/portfolio.jpg";
import work1 from "./assets/work1.png";
import work2 from "./assets/work2.png";
import work3 from "./assets/work3.png";
import work4 from "./assets/work4.png";
import work5 from "./assets/work5.png";
import work6 from "./assets/work6.png";

import bcryptImg from "./assets/bcrypt.png";
import dashboardImg from "./assets/dashboard.png";
import sharemeImg from "./assets/shareme.png";
import crudFirebaseImg from "./assets/crudFirebase.png";
import movieSiteImg from "./assets/movieSite.png";

import { TbBrandNextjs, TbBrandTailwind } from "react-icons/tb";
import { SiMongodb, SiNetlify } from "react-icons/si";

export const navLinks = ["home", "about", "skills", "portfolio", "contact"];

export const socialIcons = [
  // <FaDribbble />,
  {
    icon: <FaInstagram />,
    name: "instagram",
    url: "https://www.instagram.com/bhavik.1406/",
  },
  { icon: <FaGithub />, name: "github", url: "https://github.com/bhavik786" },
  {
    icon: <FaLinkedin />,
    name: "linkedin",
    url: "https://www.linkedin.com/in/bhavikgevariya",
  },
  // <BsMedium />
];

export const bios = [
  // {
  //   id: 1,
  //   icon: <FaUser />,
  //   key: "Name",
  //   value: "Bhavik Gevariya"
  // },
  //   {
  //     id: 2,
  //     icon: <FaPhoneAlt />,
  //     key: "Phone",
  //     value: "+14376771004"
  //   },
  {
    id: 3,
    icon: <FaPaperPlane />,
    key: "Email",
    value: "bhavikgevariya1@gmail.com",
  },
];

export const icons = [
  <FaHtml5 />,
  <FaCss3 />,
  <TbBrandTailwind />,
  <FaSass />,
  <SiMongodb />,
  <SiExpress />,
  <FaReact />,
  <FaNodeJs />,
  <SiSequelize />,
  <FaGithub />,
  <TbBrandNextjs />,
  <SiTypescript />,
  <SiNetlify />,
  <FaDigitalOcean />,
  <FaStackOverflow />,
];

export const experiences = [
  {
    id: 1,
    year: "2 Year",
    position: "Software Engineer",
    company: "Belymon Infotech",
  },
  {
    id: 2,
    year: "2 Year",
    position: "Software Engineer",
    company: "V2 Web Solutions",
  },
  // {
  //   id: 2,
  //   year: "2021",
  //   position: "Junior Web Developer",
  //   company: "shop.com.mm"
  // },
  // {
  //   id: 3,
  //   year: "2019",
  //   position: "Intern Web Dveloper",
  //   company: "shop.com.mm"
  // }
];
export const finishes = [
  {
    id: 1,
    number: "4+",
    itemName: "Years Of Experience",
  },
  //   {
  //   id: 2,
  //   number: "10+",
  //   itemName: "Clients Served"
  // }
  // {
  //   id: 2,
  //   number: "150+",
  //   itemName: "Satisfied Customers"
  // },
  // {
  //   id: 3,
  //   number: "669+",
  //   itemName: "Designed Items"
  // },
  // {
  //   id: 4,
  //   number: "117+",
  //   itemName: "Clients Served"
  // }
];
export const workImages = [
  {
    id: 1,
    img: dashboardImg,
    name: "project 1",
    category: "web",
    url: "https://dashboard-react-demo.netlify.app/ecommerce",
  },
  {
    id: 2,
    img: sharemeImg,
    name: "project 2",
    category: "web",
    url: "https://shareme-786.netlify.app/",
  },
  {
    id: 3,
    img: crudFirebaseImg,
    name: "project 3",
    category: "web",
    url: "https://chatting-app-firebase.netlify.app/login",
  },
  {
    id: 4,
    img: movieSiteImg,
    name: "project 4",
    category: "web",
    url: "https://movie-site-react-js.netlify.app/",
  },
];

export const workNavs = [
  // "All", "Web",
  // "App",
  // "Design"
];

export const contacts = [
  {
    id: 1,
    icon: <FaMapMarkerAlt />,
    infoText: "Toronto,Ontario, Canada",
  },
  {
    id: 2,
    icon: <FaPaperPlane />,
    infoText: "bhavikgevariya1@gmail.com",
  },
  {
    id: 3,
    icon: <FaPhoneAlt />,
    infoText: "+14376771004",
  },
];
